import * as actionTypes from './actionTypes'

import levelAxios from '../../axios/level'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import masterAxios from '../../axios/masterValue'
import { saveFileFromResponse } from '../../helpers/utils'

export const fetchLevel = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }
    dispatch(fetchLevelStart())

    levelAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchLevelSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchLevelFailed(error))
      })
  }
}

export const fetchLevelStart = () => {
  return {
    type: actionTypes.FETCH_LEVEL_START
  }
}

export const fetchLevelSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_LEVEL_SUCCESS,
    pagination,
    records
  }
}

export const fetchLevelFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_LEVEL_FAILED,
    errorMessage
  }
}

export const fetchLevelById = recordId => {
  return dispatch => {
    dispatch(fetchLevelStart())
    levelAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchLevelByIdSuccess(response.data.data))
          // dispatch(fetchParentLevelOptions(response.data.data.appraisal_type_id))
        }
      })
      .catch(error => {
        dispatch(fetchLevelFailed(error))
      })
  }
}

export const fetchLevelByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_LEVEL_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedLevelRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_LEVEL_RECORD
  }
}

export const createLevel = (recordData, page) => {
  return dispatch => {
    dispatch(createLevelStart())

    levelAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'Level Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createLevelSuccess())
          dispatch(fetchLevel(page))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Level field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createLevelFailed())
      })
  }
}

export const createLevelStart = () => {
  return {
    type: actionTypes.CREATE_LEVEL_START
  }
}

export const createLevelSuccess = () => {
  return {
    type: actionTypes.CREATE_LEVEL_SUCCESS
  }
}

export const createLevelFailed = () => {
  return {
    type: actionTypes.CREATE_LEVEL_FAILED
  }
}

export const updateLevel = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateLevelStart())

    levelAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Level Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(updateLevelSuccess())
        dispatch(fetchLevel(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Level field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateLevelFailed())
      })
  }
}

export const updateLevelStart = () => {
  return {
    type: actionTypes.UPDATE_LEVEL_START
  }
}

export const updateLevelSuccess = () => {
  return {
    type: actionTypes.UPDATE_LEVEL_SUCCESS
  }
}

export const updateLevelFailed = () => {
  return {
    type: actionTypes.UPDATE_LEVEL_FAILED
  }
}

export const deleteLevel = (recordId, page) => {
  return dispatch => {
    dispatch(deleteLevelStart())
    levelAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Level Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deleteLevelSuccess())
        dispatch(fetchLevel(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: error.response.data.message,
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteLevelFailed())
      })
  }
}

export const deleteLevelStart = () => {
  return {
    type: actionTypes.DELETE_LEVEL_START
  }
}

export const deleteLevelSuccess = () => {
  return {
    type: actionTypes.DELETE_LEVEL_SUCCESS
  }
}

export const deleteLevelFailed = () => {
  return {
    type: actionTypes.DELETE_LEVEL_FAILED
  }
}

export const fetchParentLevelOptions = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchParentLevelOptionsStart())
    levelAxios
      .get('/dropdown', { params })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchParentLevelOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchParentLevelOptionsFailed(error))
      })
  }
}

export const fetchParentLevelOptionsStart = () => {
  return {
    type: actionTypes.FETCH_PARENT_LEVEL_OPTIONS_START
  }
}

export const fetchParentLevelOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_PARENT_LEVEL_OPTIONS_SUCCESS,
    data
  }
}

export const fetchParentLevelOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PARENT_LEVEL_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchAppraisalTypeOptions = () => {
  return dispatch => {
    dispatch(fetchAppraisalTypeOptionsStart())
    masterAxios
      .get('/appraisal_type')
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchAppraisalTypeOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchAppraisalTypeOptionsFailed(error))
      })
  }
}

export const fetchAppraisalTypeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_START
  }
}

export const fetchAppraisalTypeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_SUCCESS,
    data
  }
}

export const fetchAppraisalTypeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FAILED,
    errorMessage
  }
}

export const importLevel = importFile => {
  return dispatch => {
    dispatch(importLevelStart())
    let formData = new FormData()
    formData.append('file', importFile)

    levelAxios
      .post('/import', formData)
      .then(response => {
        if (response.status === 200) {
          dispatch(importLevelSuccess(response.data))
          dispatch(fetchLevel())
          dispatch(
            enqueueSnackbar({
              message: 'Level Imported',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Level field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(importLevelFailed(error))
      })
  }
}

export const importLevelStart = () => {
  return {
    type: actionTypes.IMPORT_LEVEL_START
  }
}

export const importLevelSuccess = () => {
  return {
    type: actionTypes.IMPORT_LEVEL_SUCCESS
  }
}

export const importLevelFailed = errorMessage => {
  return {
    type: actionTypes.IMPORT_LEVEL_FAILED,
    errorMessage
  }
}

export const exportLevels = filterOptions => {
  return dispatch => {
    dispatch(exportLevelsStart())
    let params = null
    if (filterOptions) {
      params = {
        ...filterOptions
      }
    }
    levelAxios
      .get('/export', {
        params,
        responseType: 'blob'
      })
      .then(response => {
        if (response.status === 200) {
          saveFileFromResponse(response)
          dispatch(
            enqueueSnackbar({
              message: 'Level Exported',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(exportLevelsSuccess())
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Level field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.data,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(exportLevelsFailed(error))
      })
  }
}

export const exportLevelsStart = () => {
  return {
    type: actionTypes.EXPORT_LEVEL_START
  }
}

export const exportLevelsSuccess = () => {
  return {
    type: actionTypes.EXPORT_LEVEL_SUCCESS
  }
}

export const exportLevelsFailed = errorMessage => {
  return {
    type: actionTypes.EXPORT_LEVEL_FAILED,
    errorMessage
  }
}

export const downloadLevelTemplate = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(downloadLevelTemplateStart())
    levelAxios
      .get('/download', {
        responseType: 'blob',
        params
      })
      .then(response => {
        if (response.status === 200) {
          saveFileFromResponse(response)
          dispatch(
            enqueueSnackbar({
              message: 'Level Template Downloaded',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(downloadLevelTemplateSuccess())
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Level field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.data,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(downloadLevelTemplateFailed(error))
      })
  }
}

export const downloadLevelTemplateStart = () => {
  return {
    type: actionTypes.DOWNLOAD_LEVEL_TEMPLATE_START
  }
}

export const downloadLevelTemplateSuccess = () => {
  return {
    type: actionTypes.DOWNLOAD_LEVEL_TEMPLATE_SUCCESS
  }
}

export const downloadLevelTemplateFailed = errorMessage => {
  return {
    type: actionTypes.DOWNLOAD_LEVEL_TEMPLATE_FAILED,
    errorMessage
  }
}

export const fetchLevelFilterCompany = filter => {
  return dispatch => {
    dispatch(fetchLevelFilterCompanyStart())
    levelAxios
      .get('/company/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchLevelFilterCompanySuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchLevelFilterCompanyFailed(error))
      })
  }
}

export const fetchLevelFilterCompanyStart = () => {
  return {
    type: actionTypes.FETCH_LEVEL_FILTER_COMPANY_START
  }
}

export const fetchLevelFilterCompanySuccess = data => {
  return {
    type: actionTypes.FETCH_LEVEL_FILTER_COMPANY_SUCCESS,
    data
  }
}

export const fetchLevelFilterCompanyFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_LEVEL_FILTER_COMPANY_FAILED,
    errorMessage
  }
}

export const fetchLevelFilterLevel = filter => {
  return dispatch => {
    dispatch(fetchLevelFilterLevelStart())
    levelAxios
      .get('/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchLevelFilterLevelSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchLevelFilterLevelFailed(error))
      })
  }
}

export const fetchLevelFilterLevelStart = () => {
  return {
    type: actionTypes.FETCH_LEVEL_FILTER_LEVEL_START
  }
}

export const fetchLevelFilterLevelSuccess = data => {
  return {
    type: actionTypes.FETCH_LEVEL_FILTER_LEVEL_SUCCESS,
    data
  }
}

export const fetchLevelFilterLevelFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_LEVEL_FILTER_LEVEL_FAILED,
    errorMessage
  }
}

export const fetchLevelFilterParentLevel = filter => {
  return dispatch => {
    dispatch(fetchLevelFilterParentLevelStart())
    levelAxios
      .get('/parent_level/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchLevelFilterParentLevelSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchLevelFilterParentLevelFailed(error))
      })
  }
}

export const fetchLevelFilterParentLevelStart = () => {
  return {
    type: actionTypes.FETCH_LEVEL_FILTER_PARENT_LEVEL_START
  }
}

export const fetchLevelFilterParentLevelSuccess = data => {
  return {
    type: actionTypes.FETCH_LEVEL_FILTER_PARENT_LEVEL_SUCCESS,
    data
  }
}

export const fetchLevelFilterParentLevelFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_LEVEL_FILTER_PARENT_LEVEL_FAILED,
    errorMessage
  }
}

export const fetchLevelFilterActive = () => {
  return dispatch => {
    dispatch(fetchLevelFilterActiveStart())
    let active = [
      {
        active_id: 1,
        active_code: 1,
        active_name: 'Active'
      },
      {
        active_id: 0,
        active_code: 0,
        active_name: 'Inactive'
      }
    ]

    if (active) {
      dispatch(fetchLevelFilterActiveSuccess(active))
    } else {
      dispatch(fetchLevelFilterActiveFailed('Get active fail'))
    }
  }
}

export const fetchLevelFilterActiveStart = () => {
  return {
    type: actionTypes.FETCH_LEVEL_FILTER_ACTIVE_START
  }
}

export const fetchLevelFilterActiveSuccess = data => {
  return {
    type: actionTypes.FETCH_LEVEL_FILTER_ACTIVE_SUCCESS,
    data
  }
}

export const fetchLevelFilterActiveFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_LEVEL_FILTER_ACTIVE_FAILED,
    errorMessage
  }
}

export const fetchLevelTags = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchLevelTagsStart())
    levelAxios
      .get('/tags', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchLevelTagsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchLevelTagsFailed(error))
      })
  }
}

const fetchLevelTagsStart = () => {
  return {
    type: actionTypes.FETCH_LEVEL_TAGS_START
  }
}

const fetchLevelTagsSuccess = data => {
  return {
    type: actionTypes.FETCH_LEVEL_TAGS_SUCCESS,
    data
  }
}

const fetchLevelTagsFailed = error => {
  return {
    type: actionTypes.FETCH_LEVEL_TAGS_FAILED
  }
}
